export enum SchoolCandidateStatus {
  notSent = 1,
  onSchoolList,
  confirmation,
}
